<template>
  <div class="contentDarkMode">
    <transition mode="out-in" name="fade">
      <component
          :is="setComponentName"
          @startStudy="startStudy"/>
    </transition>
  </div>
</template>

<script>
/**
 * 컨텐츠 학습창 메인 컴포넌트(Content learning main component)
 *
 * @author minkyoung.park@emcast.com
 */
import microLearnApi from '@/api/microLearnApi';
import Objective from '../components/microStudy/Objective.vue'
import VideoType from '@/components/microStudy/VideoType.vue'
import SlideType from '@/components/microStudy/SlideType.vue'
import PdfType from '@/components/microStudy/PdfType2.vue'
import HtmlType from '@/components/microStudy/HtmlType.vue'
import InteractiveHtmlType from '@/components/microStudy/InteractiveHtmlType.vue'
import CegosHtmlType from '@/components/microStudy/CegosHtmlType.vue'
import ExamIntro from '../components/microExam/Intro.vue';

import CSTotalType from '@/components/microStudy/computerScience/components/Total.vue'
import MicroExamIntro from "@/components/microExam/Intro.vue";

export default {
  name: 'studyContainer',

  components: {
    Objective, VideoType, SlideType, PdfType, HtmlType, InteractiveHtmlType, CegosHtmlType,
    MicroExamIntro, CSTotalType
  },

  data() {
    return {
      componentName: '',
      lessonData: null,
      lessonContentType: '',
      rate: 0,
      contentsType: ''
    }
  },

  computed: {
    setComponentName() {
      return this.componentName
    }
  },

  created() {
    this.fatchData();
  },
	
	mounted() {
		let goBackBookMarkLessson = localStorage.getItem('bookMarkLesson')
		let goBackLikeLessson = localStorage.getItem('likeLesson')
		if (goBackBookMarkLessson == 'setGoBackBookMarkLesson') {
			localStorage.removeItem('bookMarkLesson');
			localStorage.setItem('videoBookMarkLesson', 'setVideoBookMarkLesson')
		} else if (goBackLikeLessson == 'setlikeLesson') {
			localStorage.removeItem('likeLesson');
			localStorage.setItem('videoLikeLesson', 'setVideoLikeLesson')
		}
		this.$emit('startStudy')
	},

  watch: {
    '$route'(to, from) {
      if (to.params.progressionId.toString() !== from.params.progressionId.toString()) {
        this.fatchData();
      }
    }
  },

  methods: {
    // get lesson data
    fatchData(componentName) {
      if (componentName) {
        this.componentName = componentName;
      }
      let params = this.setParams();
      microLearnApi.learnLessonContents(params).then((response) => {
        this.lessonData = response.data.data;
        let contentsType = this.lessonData.contentsType.value;
        if(contentsType === 'COMPUTER_SCIENCE') {
          this.lessonContentType = contentsType;
        } else {
          this.lessonContentType = this.lessonData.type.value;
        }
        this.startStudy();
      }).catch((err) => {})
    },

    // 학습 창으로 이동(move learning contents)
    startStudy() {
      if (this.lessonContentType === 'COMPUTER_SCIENCE') {
        this.componentName = 'CSTotalType';
      } else if (this.lessonContentType === 'VIDEO') {
        this.componentName = 'VideoType'
      } else if (this.lessonContentType === 'SLIDE') {
        this.componentName = 'SlideType'
      } else if (this.lessonContentType === 'PDF') {
        this.componentName = 'PdfType'
      } else if (this.lessonContentType === 'HTML') {
        this.componentName = 'HtmlType'
      } else if (this.lessonContentType === 'INTERACTIVE_HTML') {
        this.componentName = 'InteractiveHtmlType'
      } else if (this.lessonContentType === 'CEGOS') {
        this.componentName = 'CegosHtmlType'
      } else if (this.lessonContentType === 'LIVE_SESSION') {
        this.zoomMetting()
      }
    },

    // set ContentsType
    setContentsType(type) {
      this.componentName = type
    },

    zoomMetting(target = '_blank') {
      this.updateProgress()
      window.open(this.lessonData.liveSession.url, target);
    },

    updateProgress() {
      let params = this.setParamsProgress()
      let responseData = null

      if (this.rate < 100) {
        microLearnApi.learnLessonProgression(params).then((response) => {
          responseData = response.data.data;
          this.rate = responseData.rate
          this.last = responseData.last
          this.$router.push({
            name: 'MicroDegreeView',
            params: {learnId: this.$route.params.learnId},
            query: this.$route.query
          })
        }).catch((err) => {
        })
      }
    },

    // API 파라미터 설정(set parameter)
    setParamsProgress() {
      let params = {
        total: 0,
        current: 0,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId
      }
      return params
    },

    // set parameter
    setParams() {
      let params = {
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId
      }
      return params
    },

  },

}
</script>
